module.exports = __webpack_public_path__ + "static/media/Company-bg.4c624a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Company-bg.jpg
// module id = 315
// module chunks = 1